module.exports = __webpack_public_path__ + "static/media/WomanOnChair.a9177b47.png";